import { Voucher } from '../../data/interfaces';
import { createAction, props } from '@ngrx/store';

export const loadVouchers = createAction(
    '[Vouchers] Load Vouchers',
    props<{ filter: any }>()
);

export const loadVouchersSuccess = createAction(
    '[Vouchers] Load Vouchers Success',
    props<{
        currentPage: number;
        vouchers: Voucher[];
        totalCount: number;
        totalPages: number
    }>()
);

export const loadVouchersFailure = createAction(
    '[Vouchers] Load Vouchers Failure',
    props<{ error: string }>()
);

export const createVoucher = createAction(
    '[Vouchers] Create Voucher',
    props<{ voucher: Voucher }>()
);

export const createVoucherSuccess = createAction(
    '[Vouchers] Create Voucher Success',
    props<{ voucher: Voucher }>()
);

export const createVoucherFailure = createAction(
    '[Vouchers] Create Voucher Failure',
    props<{ error: string }>()
);

export const updateVoucher = createAction(
    '[Vouchers] Update Voucher',
    props<{ voucher: Voucher }>()
);

export const updateVoucherSuccess = createAction(
    '[Vouchers] Update Voucher Success',
    props<{ voucher: Voucher }>()
);

export const updateVoucherFailure = createAction(
    '[Vouchers] Update Voucher Failure',
    props<{ error: string }>()
);

export const deleteVoucher = createAction(
    '[Vouchers] Delete Voucher',
    props<{ voucherId: string }>()
);

export const deleteVoucherSuccess = createAction(
    '[Vouchers] Delete Voucher Success',
    props<{ voucherId: string }>()
);

export const deleteVoucherFailure = createAction(
    '[Vouchers] Delete Voucher Failure',
    props<{ error: string }>()
);